import React from 'react'
import {
    Home as HomeIcon,
    FilterNone as UIElementsIcon,
    BorderAll as TableIcon,
    QuestionAnswer as SupportIcon,
    LibraryBooks as LibraryIcon,
    HelpOutline as FAQIcon,
    BarChart as ChartIcon,
    Map as MapIcon,
    Apps as CoreIcon,
    Description as DescriptionIcon,
    ShoppingCart as ShoppingCartIcon,
    StarBorder as ExtraIcon,
    Chat as ChatIcon,
    Add as AddSectionIcon,
    FolderOpen as FolderIcon,
    Description as DocumentationIcon,
    Person as PersonIcon, HowToReg
} from '@material-ui/icons'
import { makeStyles } from '@material-ui/styles'

import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import BorderAllIcon from '@material-ui/icons/BorderAll';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import DevicesIcon from '@material-ui/icons/Devices';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import CloudOffIcon from '@material-ui/icons/CloudOff';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

// components
import Dot from './components/Dot'

const structure = [
    {id: 100, type: 'title', label: 'Devices', public: true},
    {id: 0, label: 'All', public: true, link: '/app/list-devices', icon: <DevicesIcon/>},
    {id: 1, label: 'Faults', public: false, link: '/app/monitoring/faults', icon: <ReportProblemOutlinedIcon/>},
    {id: 2, label: 'Offline', public: false, link: '/app/monitoring/offline', icon: <CloudOffIcon/>},
    {id: 3, label: 'Unmonitored', public: false, link: '/app/monitoring/unmonitored', icon: <VisibilityOffIcon/>},
    {id: 101, type: 'divider', public: false},
    {id: 102, type: 'title', label: 'Manage', public: false},
    {id: 4, label: 'Customers', public: false, link: '/app/list-customers', icon: <PeopleOutlineIcon/>},
    {id: 5, label: 'Reports', public: false, link: '/app/reports', icon: <LibraryBooksIcon/>},
    {id: 6, label: 'Occupancy', public: false, link: '/app/occupancy', icon: <HowToReg/>}
]

function AddSection() {
    const useStyles = makeStyles(theme => ({
        root: {
            backgroundColor: theme.palette.secondary.main,
            borderRadius: '50%',
            height: 30,
            width: 30,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#fff',
        },
    }))

    const classes = useStyles()

    return (
        <section className={classes.root}>
            <AddSectionIcon />
        </section>
    )
}

function Chat() {
    const useStyles = makeStyles(theme => ({
        root: {
            backgroundColor: theme.palette.primary.main,
            borderRadius: '50%',
            height: 45,
            width: 45,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#fff',
        },
    }))

    const classes = useStyles()

    return (
        <>
            <section className={classes.root}>
                <ChatIcon />
            </section>
        </>
    )
}

export default structure
